function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

/**
 * Endereco do backend.
 *
 * O nginx que serve este frontend tambem encaminha as rotas de API para o
 * backend, entao a mesma origem da pagina sempre funciona — seja o dominio
 * publico, o IP da rede ou localhost.
 *
 * Usar o valor fixo de VITE_BACKEND_URL quebra o acesso por qualquer outro
 * endereco: as chamadas viram cross-origin e o navegador bloqueia. Por isso a
 * origem atual tem prioridade, e a variavel fica como reserva para quando o
 * frontend for servido de um lugar que nao consegue encaminhar a API
 * (CDN, build aberto direto do arquivo, etc).
 */
export function getBackendUrl() {
  if (typeof window !== "undefined" && window.location?.origin?.startsWith("http")) {
    return window.location.origin;
  }

  return getConfig("VITE_BACKEND_URL");
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
